<div class="cr-version-dialog-overlay" (click)="closeDialog.emit()">
  <section class="cr-version-dialog-card" role="dialog" aria-modal="true" aria-labelledby="crVersionDialogTitle" (click)="$event.stopPropagation()">
    <button type="button" class="cr-version-dialog-close" (click)="closeDialog.emit()" aria-label="Close version dialog">
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M5 5l14 14"></path>
        <path d="M19 5 5 19"></path>
      </svg>
    </button>

    <div class="cr-version-dialog-body">
      <div class="cr-version-dialog-heading">
        <div class="cr-version-dialog-kicker">{{ mode === 'create' ? 'REVIEW' : 'HISTORY' }}</div>
        <h2 id="crVersionDialogTitle">{{ mode === 'create' ? 'Create Version ' + targetVersion + '?' : 'Restore Version ' + targetVersion + '?' }}</h2>
        <p class="cr-version-dialog-intro">
          {{ mode === 'create'
            ? 'The current ' + languageLabel + ' content is copied in as Version ' + targetVersion + ' and opens for review. Older versions keep their content and comments.'
            : 'The content of Version ' + targetVersion + ' replaces the current ' + languageLabel + ' content and is saved as Version ' + resultVersion + '. No version is deleted.'
          }}
        </p>
        @if (showUnsavedNote) {
          <p class="cr-version-dialog-note">
            {{ mode === 'create' ? 'Unsaved changes are saved first.' : 'Unsaved changes in the editor will be lost.' }}
          </p>
        }
      </div>

      <textarea
        class="cr-input cr-version-dialog-comment"
        rows="3"
        placeholder="Add comment..."
        aria-label="Comment"
        [(ngModel)]="comment"
      ></textarea>
    </div>

    <div class="cr-version-dialog-footer">
      <button type="button" class="cr-btn cr-btn-secondary" (click)="onCancel()">Cancel</button>
      <button type="button" class="cr-btn cr-btn-primary" [disabled]="busy" (click)="onConfirm()">
        {{ mode === 'create' ? 'Create Version ' + targetVersion : 'Restore Version ' + targetVersion }}
      </button>
    </div>
  </section>
</div>
